import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faPlus, faFolderOpen as fafolderopen, faUser } from '@fortawesome/free-solid-svg-icons';
import { faFile, faFolderOpen, faUserCircle } from '@fortawesome/free-regular-svg-icons';

import { GlobalService } from 'src/app/services/global.service';
import { DocumentaryService } from '../../services/documentary.service';
import { NewfolderComponent } from 'src/app/popup/newfolder/newfolder.component';
import { UploadfileComponent } from 'src/app/popup/uploadfile/uploadfile.component'
import { ChangeNameFolderComponent } from 'src/app/popup/change-name-folder/change-name-folder.component';

@Component({
  selector: 'app-documentary',
  templateUrl: './documentary.component.html',
  styleUrls: ['./documentary.component.css'],
  providers: [DocumentaryService]
})

export class DocumentaryComponent implements OnInit {
  // string
  token: string;
  folderid: string;

  // any
  root: any;
  selectedDir: any;
  activeUser: any;
  user: any;

  // array
  parentID: Array<any> = [];
  menu: Array<any> = [];
  navigationArray: Array<any> = [];

  //variabili doppie
  selectedDirTwo: Array<any> = [];
  menuTwo: Array<any> = [];
  parentIDTwo: Array<any> = [];
  folderidTwo: string;
  disableTwo = false;
  showTwo = false;

  tempID: string;
  tempIDTwo: string;


  // boolean
  show = false;
  enterIf = false;
  disable = false;
  double = false;
  

  // number
  i = 1;

  // formData
  formData: any;
  uploadForm: FormGroup;

  // Icone
  faPlus = faPlus;
  faFile = faFile;
  faFolderOpen = faFolderOpen;
  faUserCircle = faUserCircle;
  fafolderopen = fafolderopen;
  faUser = faUser;


  //test
  mq = window.matchMedia("(min-width: 700px)");

  constructor(
    private documentaryService: DocumentaryService,
    private modalService: NgbModal,
    private globals: GlobalService,
    private formBuilder: FormBuilder,
  ) {

  }

  ngOnInit() {
    this.globals.checkPage(3);
    if (!this.token) {
      this.token = this.globals.getToken();
    }
    this.activeUser = this.globals.storagedUser;
    this.getRoot();
    this.getRootSecond();
    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });
    this.formData = new FormData();

    if (this.activeUser.profile_id == 1) {
      this.double = true;
    }
  }  

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadForm.get('profile').setValue(file);
    }
  }



  reload() {
    this.ngOnInit()
  }

  changeLastModify(file) {
    file.forEach((fil) => {
      if (fil.entry.isFile == true) {
        fil.entry.modifiedAt = this.globals.cleanDateAndHour(fil.entry.modifiedAt);
      }
    })
  }

  changeDimension(byte) {
    byte.forEach(byt => {
      if (byt.entry.isFile == true) {
        if (byt.entry.content.sizeInBytes < 1024) {
          Math.round(parseInt(byt.entry.content.sizeInBytes))
          byt.entry.content.sizeInBytes = byt.entry.content.sizeInBytes + " Byte";
        } else {
          if (byt.entry.content.sizeInBytes >= 1073741824) {
            byt.entry.content.sizeInBytes = byt.entry.content.sizeInBytes / 1073741824;
            byt.entry.content.sizeInBytes = Math.round(parseInt(byt.entry.content.sizeInBytes));
            byt.entry.content.sizeInBytes = byt.entry.content.sizeInBytes + " GB"
          } else {
            if (byt.entry.content.sizeInBytes >= 1048576) {
              byt.entry.content.sizeInBytes = byt.entry.content.sizeInBytes / 1048576;
              byt.entry.content.sizeInBytes = Math.round(parseInt(byt.entry.content.sizeInBytes));
              byt.entry.content.sizeInBytes = byt.entry.content.sizeInBytes + " MB"
            } else {
              if (byt.entry.content.sizeInBytes >= 1024) {
                byt.entry.content.sizeInBytes = byt.entry.content.sizeInBytes / 1024;
                byt.entry.content.sizeInBytes = Math.round(parseInt(byt.entry.content.sizeInBytes));
                byt.entry.content.sizeInBytes = byt.entry.content.sizeInBytes + " KB"
              }
            }
          }
        }
      }
    });
  }

  changeCreateAt(file) {
    file.forEach((fil) => {
      if (fil.entry.isFile == true) {
        fil.entry.createdAt = this.globals.cleanDateAndHour(fil.entry.createdAt)
      }
    })
    console.log("createAt: ", file);
    
  }

  getRoot() {
    this.documentaryService.getRoot(this.token).subscribe(
      res => {
        if (res.error) {
          return this.globals.errorSniffer(res.error);
        } else {
          this.root = res;
          this.folderid = res.folder_id
          this.navigationArray = res;
          this.selectedDir = res;
          if (this.activeUser.profile_id == 1) {
            this.root.splice("Clienti", 1);
          }
          this.changeLastModify(this.selectedDir);
          this.changeDimension(this.selectedDir);
          this.changeCreateAt(this.selectedDir);

          this.show = false;
          this.menu = [];
          this.parentID = [];
        }
      },
      err => {
        console.error("Errore in getRoot: ", err);
      }
    )

  }

  getRootSecond() {
    if (this.activeUser.profile_id == 1) {
      this.documentaryService.getFolderContent(this.token, this.activeUser.folder_id).subscribe(
        res => {
          if (res.error) {
            return this.globals.errorSniffer(res.error);
          } else {
            this.selectedDirTwo = res.list
            this.folderidTwo = res.list.folder_id
            this.showTwo = false;
            this.menuTwo = [];
            this.parentIDTwo = [];
            this.changeLastModify(this.selectedDir);
            this.changeDimension(this.selectedDir);
            this.changeCreateAt(this.selectedDir);
          }
        },
        err => {
          console.error("Errore in getFolderContent, profile ID = 1", err);
        }
      )
    }
  }

  changeFolder(file) {
    this.disable = true;
    this.documentaryService.getFolderContent(this.token, file.id).subscribe(
      res => {
        this.folderid = file.id;
        if (this.parentID.indexOf(file.id) <= 0) {
        } else {
          this.menu.splice(this.menu.indexOf(file) + 1, this.menu.length);
          let index2 = this.parentID.indexOf(file.id);
          let lungheezza2 = this.parentID.length
          let passo2 = lungheezza2 - index2
          this.parentID.splice(index2, passo2);
          this.selectedDir = res.list;
          this.changeLastModify(this.selectedDir);
          this.changeDimension(this.selectedDir);
          this.changeCreateAt(this.selectedDir);

        }
        this.disable = false;
      },
      err => {
        console.error("Errore in getFolderContent (changeFolder): ", err);

        this.disable = false;
      }
    )
  }


  changeFolderTwo(file) {
    this.disableTwo = true;
    this.documentaryService.getFolderContent(this.token, file.id).subscribe(
      res => {
        this.folderidTwo = file.id;
        if (this.parentIDTwo.indexOf(file.id) <= 0) {
        } else {
          this.menuTwo.splice(this.menuTwo.indexOf(file) + 1, this.menu.length);
          let index2 = this.parentIDTwo.indexOf(file.id);
          let lungheezza2 = this.parentIDTwo.length
          let passo2 = lungheezza2 - index2
          this.parentIDTwo.splice(index2, passo2);
          this.selectedDirTwo = res.list;

          this.changeLastModify(this.selectedDir);
          this.changeDimension(this.selectedDir);
          this.changeCreateAt(this.selectedDir);

        }
        this.disableTwo = false;
      },
      err => {
        this.disableTwo = false;
      }
    )
  }


  openFolder(file) {
    this.disable = true;
    if (file == "home") {
      this.getRoot();
    } else {
      this.documentaryService.getFolderContent(this.token, file.id).subscribe(
        res => {
          this.folderid = file.id;
          this.parentID.push(file.parentId);
          this.menu.push(file);
          this.selectedDir = res.list;
          this.changeLastModify(this.selectedDir);
          this.changeDimension(this.selectedDir);
          this.changeCreateAt(this.selectedDir);
          this.show = true;
          this.disable = false;
        },
        err => {
          console.error("Errore in openFolder: ", err);
          this.disable = false;
        }
      )
      err => {
        console.error("errore in getFolderContent(open Folder): ", err);
        this.disable = false;
      }
    }
  }

  openFolderTwo(file) {
    this.disableTwo = true;
    if (file == "home") {
      this.getRootSecond();
    } else {
      this.documentaryService.getFolderContent(this.token, file.id).subscribe(
        res => {
          this.folderidTwo = file.id;
          this.parentIDTwo.push(file.parentId);
          this.menuTwo.push(file);
          this.selectedDirTwo = res.list;
          this.changeLastModify(this.selectedDirTwo);
          this.changeDimension(this.selectedDirTwo);
          this.changeCreateAt(this.selectedDirTwo);
          this.showTwo = true;
          this.disableTwo = false;
        },
        err => {
          console.error("Errore in openFolder: ", err);
          this.disableTwo = false;
        }
      )
      err => {
        console.error("errore in getFolderContent(open Folder): ", err);
        this.disableTwo = false;
      }
    }
  }

  addChild(file) {
    if (!file.child) {
      this.documentaryService.getFolderContent(this.token, file.id).subscribe(
        res => {
          file.child = res.list;
        },
        err => {
          console.error("Error on get child: ", err);
        }
      )
    }
  }

  backFolder() {
    this.disable = true;
    if (this.menu.length - 1 == 0) {
      this.getRoot();
    } else {
      this.documentaryService.getFolderContent(this.token, this.parentID[this.parentID.length - 1]).subscribe(
        res => {
          this.folderid = this.parentID[this.parentID.length - 1]

          this.menu.splice(this.menu.length - 1, 1);
          this.parentID.splice(this.parentID.length - 1, 1);
          this.selectedDir = res.list;
          this.changeLastModify(this.selectedDir);
          this.changeDimension(this.selectedDir);
          this.changeCreateAt(this.selectedDir);
          this.disable = false;
        },
        err => {
          console.error("Errore in backFolder: ", err);
          this.disable = false;
        }
      )
    }
  }

  backFolderTwo() {
    this.disableTwo = true;
    if (this.menuTwo.length - 1 == 0) {
      this.getRootSecond();
    } else {
      this.documentaryService.getFolderContent(this.token, this.parentIDTwo[this.parentIDTwo.length - 1]).subscribe(
        res => {
          this.folderidTwo = this.parentIDTwo[this.parentIDTwo.length - 1]
          this.menuTwo.splice(this.menuTwo.length - 1, 1);
          this.parentIDTwo.splice(this.parentIDTwo.length - 1, 1);
          this.selectedDirTwo = res.list;
          this.changeLastModify(this.selectedDirTwo);
          this.changeDimension(this.selectedDirTwo);
          this.changeCreateAt(this.selectedDirTwo);
          this.disableTwo = false;
        },
        err => {
          console.error("Errore in backFolder: ", err);
          this.disableTwo = false;
        }
      )
    }
  }

  newFolder(name) {
    const modalRef = this.modalService.open(NewfolderComponent, { backdrop: 'static', centered: true, size: 'xl' });
    modalRef.componentInstance.folderName = name;
    modalRef.componentInstance.folderID = this.folderid;
    modalRef.result.then(result => {
      if (result != 'cancel') {
        this.documentaryService.getFolderContent(this.token, this.folderid).subscribe(
          res => {
            this.selectedDir = res.list;
            this.changeLastModify(this.selectedDir);
            this.changeDimension(this.selectedDir);
            this.changeCreateAt(this.selectedDir);
          },
          err => {
            console.error("Errore in getFolderContent: ", err);
          }
        )
      }
    }, reason => {
    });
  }

  newFolderTwo(name) {
    const modalRef = this.modalService.open(NewfolderComponent, { backdrop: 'static', centered: true, size: 'xl' });
    modalRef.componentInstance.folderName = name;
    modalRef.componentInstance.folderID = this.folderidTwo;
    modalRef.result.then(result => {
      if (result != 'cancel') {
        this.documentaryService.getFolderContent(this.token, this.folderidTwo).subscribe(
          res => {
            this.selectedDirTwo = res.list;
            this.changeLastModify(this.selectedDirTwo);
            this.changeDimension(this.selectedDirTwo);
            this.changeCreateAt(this.selectedDirTwo);
          },
          err => {
            console.error("Errore in getFolderContentTwo: ", err);
          }
        )
      }
    }, reason => {
    });
  }

  delFolder(file) {
    this.documentaryService.delFolder(this.token, file.id).subscribe(
      res => {
        this.documentaryService.getFolderContent(this.token, this.folderid).subscribe(
          res => {
            this.selectedDir = res.list;
            this.changeLastModify(this.selectedDir);
            this.changeDimension(this.selectedDir);
            this.changeCreateAt(this.selectedDir);
          },
          err => {
            console.error("Errore in openFolder: ", err);
            this.disable = false;
          }
        )
        err => {
          console.error("errore in getFolderContent(open Folder): ", err);
          this.disable = false;
        }
      }
    )
    err => {
      console.error("Errore in newFolder: ", err);
    }
  }

  delFolderTwo(file) {
    this.documentaryService.delFolder(this.token, file.id).subscribe(
      res => {
        this.documentaryService.getFolderContent(this.token, this.folderidTwo).subscribe(
          res => {
            this.selectedDirTwo = res.list;
            this.changeLastModify(this.selectedDirTwo);
            this.changeDimension(this.selectedDirTwo);
            this.changeCreateAt(this.selectedDirTwo);
            this.showTwo = true;
            this.disableTwo = false;
          },
          err => {
            console.error("Errore in openFolder: ", err);
            this.disableTwo = false;
          }
        )
        err => {
          console.error("errore in getFolderContent(open Folder): ", err);
          this.disableTwo = false;
        }
      })
    err => {
      console.error("Errore in newFolder: ", err);
    }
  }

  updateFolderName(id) {
    let obj
    this.documentaryService.updateName(this.token, id, obj).subscribe(
      res => {
        this.documentaryService.getFolderContent(this.token, this.folderid).subscribe(
          res => {
            this.selectedDir = res.list;
            this.changeLastModify(this.selectedDir);
            this.changeDimension(this.selectedDir);
            this.changeCreateAt(this.selectedDir);
          },
          err => {
            console.error("Errore in openFolder: ", err);
            this.disable = false;
          }
        )
        err => {
          console.error("errore in getFolderContent(open Folder): ", err);
          this.disable = false;
        }

      },
      err => {
        console.error("Errore in newFolder: ", err);
      }
    )
  }
  updateFolderNameTwo(id) {
    console.log(id);

    let obj
    this.documentaryService.updateName(this.token, id, obj).subscribe(
      res => {
        this.documentaryService.getFolderContent(this.token, this.folderidTwo).subscribe(
          res => {
            this.selectedDirTwo = res.list;
            this.changeLastModify(this.selectedDirTwo);
            this.changeDimension(this.selectedDirTwo);
            this.changeCreateAt(this.selectedDirTwo);
          },
          err => {
            console.error("Errore in openFolder: ", err);
            this.disable = false;
          }
        )
        err => {
          console.error("errore in getFolderContent(open Folder): ", err);
          this.disable = false;
        }

      },
      err => {
        console.error("Errore in newFolder: ", err);
      }
    )
  }


  openPopup(file) {
    const modalRef = this.modalService.open(ChangeNameFolderComponent, { backdrop: 'static', centered: true, size: 'xl' });
    modalRef.componentInstance.id = file.id;
    modalRef.componentInstance.folderName = file.name;
    modalRef.result.then(result => {
      if (result != 'Cancel') {
        this.documentaryService.getFolderContent(this.token, this.folderid).subscribe(
          res => {
            this.selectedDir = res.list;
            this.changeLastModify(this.selectedDir);
            this.changeDimension(this.selectedDir);
            this.changeCreateAt(this.selectedDir);
          },
          err => {
            console.error("Errore in openFolder: ", err);
            this.disable = false;
          }
        )
        err => {
          console.error("errore in getFolderContent(open Folder): ", err);
          this.disable = false;
        }


      }
      err => {
        console.error("Errore in getFolderContent: ", err);
      }
    }, reason => {
    });
  }

  openPopupTwo(file) {
    const modalRef = this.modalService.open(ChangeNameFolderComponent, { backdrop: 'static', centered: true, size: 'xl' });
    modalRef.componentInstance.id = file.id;
    modalRef.componentInstance.folderName = file.name;
    modalRef.result.then(result => {
      if (result != 'Cancel') {
        this.documentaryService.getFolderContent(this.token, this.folderidTwo).subscribe(
          res => {
            this.selectedDirTwo = res.list;
            this.changeLastModify(this.selectedDirTwo);
            this.changeDimension(this.selectedDirTwo);
            this.changeCreateAt(this.selectedDirTwo);
          },
          err => {
            console.error("Errore in openFolder: ", err);
            this.disable = false;
          }
        )
        err => {
          console.error("errore in getFolderContent(open Folder): ", err);
          this.disable = false;
        }


      }
      err => {
        console.error("Errore in getFolderContent: ", err);
      }
    }, reason => {
    });
  }



  download(file) {
    this.documentaryService.getContent(this.token, file.id).subscribe(res => {
      let url = window.URL.createObjectURL(res);
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = file.name;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    });
  }

  uploadFile() {
    const modalRef = this.modalService.open(UploadfileComponent, { backdrop: 'static', centered: true, size: 'xl' });
    modalRef.componentInstance.id = this.folderid;
    modalRef.result.then((result) => {
      if (result != 'Cancel') {
        this.documentaryService.getFolderContent(this.token, this.folderid).subscribe(
          res => {
            this.selectedDir = res.list;
            this.changeLastModify(this.selectedDir);
            this.changeDimension(this.selectedDir);
            this.changeCreateAt(this.selectedDir);
          },
          err => {
            console.error("Errore in openFolder: ", err);
            this.disable = false;
          }
        )
        err => {
          console.error("errore in getFolderContent(open Folder): ", err);
          this.disable = false;
        }


      }
    }, reason => {
      if (reason != 'cancel') {
        this.documentaryService.getFolderContent(this.token, this.folderid).subscribe(
          res => {
            this.selectedDir = res.list;
            this.documentaryService.getFolderContent(this.token, this.folderidTwo).subscribe(
              res => {
                this.selectedDir = res.list;
                this.changeLastModify(this.selectedDir);
                this.changeDimension(this.selectedDir);
                this.changeCreateAt(this.selectedDir);
              },
              err => {
                console.error("Errore in getFolderContent: ", err);
              }
            )
          },
          err => {
            console.error("Errore in getFolderContent: ", err);
          }
        )
      }
    })
  }

  uploadFileTwo() {
    const modalRef = this.modalService.open(UploadfileComponent, { backdrop: 'static', centered: true, size: 'xl' });
    modalRef.componentInstance.id = this.folderidTwo;
    modalRef.result.then((result) => {
      if (result != 'Cancel') {
        if (this.activeUser.profile_id == 1) {
          this.documentaryService.getFolderContent(this.token, this.folderidTwo).subscribe(
            res => {
              this.selectedDirTwo = res.list;
              this.changeLastModify(this.selectedDir);
              this.changeDimension(this.selectedDir);
              this.changeCreateAt(this.selectedDir);
              this.showTwo = true;
              this.disableTwo = false;
            },
            err => {
              console.error("Errore in openFolder: ", err);
              this.disableTwo = false;
            }
          )
          err => {
            console.error("errore in getFolderContent(open Folder): ", err);
            this.disableTwo = false;
          }
        } else {
          this.documentaryService.getFolderContent(this.token, this.folderid).subscribe(
            res => {
              this.selectedDir = res.list;
              this.changeLastModify(this.selectedDir);
              this.changeDimension(this.selectedDir);
              this.changeCreateAt(this.selectedDir);
            },
            err => {
              console.error("Errore in openFolder: ", err);
              this.disable = false;
            }
          )
          err => {
            console.error("errore in getFolderContent(open Folder): ", err);
            this.disable = false;
          }
        }

      }
    }, reason => {
      if (reason != 'cancel') {
        this.documentaryService.getFolderContent(this.token, this.folderid).subscribe(
          res => {
            this.selectedDir = res.list;
            this.documentaryService.getFolderContent(this.token, this.folderidTwo).subscribe(
              res => {
                this.selectedDir = res.list;
                this.changeLastModify(this.selectedDir);
                this.changeDimension(this.selectedDir);
                this.changeCreateAt(this.selectedDir);
              },
              err => {
                console.error("Errore in getFolderContent: ", err);
              }
            )
          },
          err => {
            console.error("Errore in getFolderContent: ", err);
          }
        )
      }
    })
  }

  onSubmit() {
    const formData = new FormData();
    formData.append('files', this.uploadForm.get('profile').value);
    this.documentaryService.uploadFile(this.token, this.selectedDir[0].entry.parentId, formData).subscribe(
      (res) => { },
      (err) => console.error(err)
    );
  }



}



// @HostListener('window:orientationchange', ['$event'])
//   onOrientationChange(event) {
//     console.log('orientationChanged');
//     this.detectPX();
//     console.log(event);
//     console.log()
//   }

// this.user = this.globals.user;
//     if (this.mq.matches) {
//       this.phone = false;
//       console.log();

//     } else {
//       this.phone = true;
//     }

// phone: boolean;

// detectPX() {
//   console.log(this.activeUser);

//   if (this.mq.matches) {
//     if (this.phone) {
//       //più grande di700px
//       this.phone = false;
//       if (this.menu.length - 1 == 0) {
//         this.getRoot()
//       } else {
//         this.documentaryService.getFolderContent(this.token, this.folderid).subscribe(
//           res => {
//             this.selectedDir = res.list;
//             this.changeLastModify(this.selectedDir);
//             this.changeDimension(this.selectedDir);
//             this.changeCreateAt(this.selectedDir);
//           }, err => {
//             console.error("Errorie in getFolderContent: ", err);

//           }
//         )

//         if (this.user.profile_id == 1) {
//           this.documentaryService.getFolderContent(this.token, this.folderidTwo).subscribe(
//             res => {
//               this.selectedDirTwo = res.list;
//               this.changeLastModify(this.selectedDirTwo);
//               this.changeDimension(this.selectedDirTwo);
//               this.changeCreateAt(this.selectedDirTwo);
//             },
//             err => {
//               console.error("Errore in openFolder: ", err);
//               this.disable = false;
//             }
//           )
//         }
//       }

//     } else {
//       if (!this.phone) {
//         //più piccolo di 700px
//         this.phone = true;
//         this.documentaryService.getFolderContent(this.token, this.folderid).subscribe(
//           res => {
//             this.selectedDir = res.list;
//             this.changeLastModify(this.selectedDir);
//             this.changeDimension(this.selectedDir);
//             this.changeCreateAt(this.selectedDir);
//           }
//         )
//       }
//     }

//   }
// }